/**
 * @generated SignedSource<<17e00dba5f202466eece6c6b9c38e515>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

var node = function () {
  var v0 = {
      "kind": "Variable",
      "name": "operationType",
      "variableName": "operationType"
    },
    v1 = {
      "kind": "ScalarField",
      "name": "asapIssuer"
    },
    v2 = {
      "kind": "ScalarField",
      "name": "mediaCollectionName"
    },
    v3 = {
      "kind": "ScalarField",
      "name": "mediaToken"
    },
    v4 = {
      "kind": "ScalarField",
      "name": "mediaUrl"
    };
  return {
    "argumentDefinitions": [{
      "kind": "RootArgument",
      "name": "hubAri"
    }, {
      "kind": "RootArgument",
      "name": "operationType"
    }, {
      "kind": "RootArgument",
      "name": "pageAri"
    }],
    "kind": "Fragment",
    "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
    "selections": [{
      "kind": "RequiredField",
      "field": {
        "args": [{
          "kind": "Variable",
          "name": "ari",
          "variableName": "hubAri"
        }, v0 /*: any*/],
        "concreteType": "HelpCenterMediaConfig",
        "kind": "LinkedField",
        "name": "hubMediaConfig",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": v1 /*: any*/,
          "action": "THROW",
          "path": "hubMediaConfig.asapIssuer"
        }, {
          "kind": "RequiredField",
          "field": v2 /*: any*/,
          "action": "THROW",
          "path": "hubMediaConfig.mediaCollectionName"
        }, {
          "kind": "RequiredField",
          "field": v3 /*: any*/,
          "action": "THROW",
          "path": "hubMediaConfig.mediaToken"
        }, {
          "kind": "RequiredField",
          "field": v4 /*: any*/,
          "action": "THROW",
          "path": "hubMediaConfig.mediaUrl"
        }]
      },
      "action": "THROW",
      "path": "hubMediaConfig"
    }, {
      "kind": "RequiredField",
      "field": {
        "alias": "pageMediaConfig",
        "args": [{
          "kind": "Variable",
          "name": "ari",
          "variableName": "pageAri"
        }, v0 /*: any*/],
        "concreteType": "HelpCenterMediaConfig",
        "kind": "LinkedField",
        "name": "hubMediaConfig",
        "plural": false,
        "selections": [{
          "kind": "RequiredField",
          "field": v1 /*: any*/,
          "action": "THROW",
          "path": "pageMediaConfig.asapIssuer"
        }, {
          "kind": "RequiredField",
          "field": v2 /*: any*/,
          "action": "THROW",
          "path": "pageMediaConfig.mediaCollectionName"
        }, {
          "kind": "RequiredField",
          "field": v3 /*: any*/,
          "action": "THROW",
          "path": "pageMediaConfig.mediaToken"
        }, {
          "kind": "RequiredField",
          "field": v4 /*: any*/,
          "action": "THROW",
          "path": "pageMediaConfig.mediaUrl"
        }]
      },
      "action": "THROW",
      "path": "pageMediaConfig"
    }, {
      "args": [{
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "hubAri"
      }],
      "kind": "LinkedField",
      "name": "helpCenterById",
      "plural": false,
      "selections": [{
        "kind": "InlineFragment",
        "selections": [{
          "kind": "ScalarField",
          "name": "type"
        }, {
          "concreteType": "HelpCenterBranding",
          "kind": "LinkedField",
          "name": "helpCenterBranding",
          "plural": false,
          "selections": [{
            "concreteType": "HelpCenterLogo",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "name": "fileId"
            }, {
              "kind": "ScalarField",
              "name": "url"
            }]
          }, {
            "concreteType": "HelpCenterBrandingColors",
            "kind": "LinkedField",
            "name": "colors",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "name": "primary"
            }]
          }]
        }],
        "type": "HelpCenter"
      }]
    }],
    "type": "HelpCenterQueryApi"
  };
}();
node.hash = "f75d668327da2ebfcff1492795ce5404";
export default node;